import { Extension } from '@tiptap/core';

export const Editorid = Extension.create({
   name: 'editorid',

   addStorage() {
      return {
         editorid: null,
      };
   },

   onCreate() {
      this.storage.editorid = this.options.editorid;
   },
});
